module.exports = __webpack_public_path__ + "videos/3d_jp.95fc807.mp4";